export enum MarketTypes {
  WINNER = 'Winner',
  THREE_BALL = 'ThreeBall'
}
